class PagesNavigation extends HTMLElement {
  connectedCallback() {
    this.links = this.querySelectorAll('.pages-navigation__link');
    this.mediaItems = this.querySelectorAll('.pages-navigation__image-item');

    this.links.forEach((link) => {
      link.addEventListener('mouseenter', this.onEnter.bind(this));
    });

    this.querySelectorAll('video:not([data-lazy])').forEach((video) => {
      if (video.dataset.userPaused !== 'true') video.play().catch(() => {});
    });
  }

  onEnter(event) {
    const index = event.currentTarget.closest('.pages-navigation__item').dataset.index;
    this.mediaItems.forEach((item) => {
      const isActive = item.dataset.index === index;
      item.classList.toggle('is-active', isActive);
      if (isActive) {
        const video = item.querySelector('video');
        if (video && video.dataset.userPaused !== 'true') video.play().catch(() => {});
      }
    });
  }
}

customElements.define('pages-navigation', PagesNavigation);
